document.addEventListener('DOMContentLoaded', function () {
    window.loadGoogleMapsScript = function () {
        const script = document.createElement('script');  
        const apiKey = google_maps_api;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initializePage&libraries=places&v=weekly`;
        script.defer = true;
        document.head.appendChild(script);
    };
    loadGoogleMapsScript();
});